import React, {PropsWithChildren} from 'react';
import {Box, Typography} from '@mui/material';
import {withStyles} from 'tss-react/mui';

import {ApolloError} from '@apollo/client';
import styles from './styles';
import ErrorIcon from '../../theme/styled-components/ErrorIcon';
import {SaltusAny} from '../../utils/SaltusAny';

const ErrorMessage: React.FC<
  PropsWithChildren<{
    classes?: SaltusAny;
    error: Pick<ApolloError, 'message'>;
  }>
> = ({classes, error}) => (
  <Box data-test="Error message display" className={classes.infoBox}>
    <Box className={classes.infoBoxIcon}>
      <Box className={classes.errorIconContainer}>
        <ErrorIcon className={classes.errorIcon} />
      </Box>
    </Box>
    <Typography align="left" className={classes.infoBoxText} variant="body2">
      Error: {error.message}
    </Typography>
  </Box>
);

export default withStyles(ErrorMessage, styles);
